<template>
  <div class="header__notify">
    <div
      class="menu-icon"
      @click="showDrawer"
    >
      <span>
        <a-badge
          dot
          :count="hasUnreadMessage"
        >
          <a-icon
            type="bell"
            class="menu-icon-item"
          />
        </a-badge>
      </span>
    </div>
    <a-drawer
      :visible="drawerVisible"
      width="360"
      placement="right"
      destroy-on-close
      title="通知"
      wrap-class-name="message-wrapper"
      @close="closeDrawer"
    >
      <div class="header__notify__tabs d-flex row ">
        <div
          @click="handleMenuChagne(1)"
          class="notify d-flex row align-center"
          :class="currentTab === 1 ? 'notify_chosed' : 'notify_normal'"
        >
          未读
          <div
            v-if="totalUnread"
            class="notify_number"
          >{{ totalUnread }}</div>
        </div>
        <div
          @click="handleMenuChagne(0)"
          class="notify"
          :class="currentTab === 0 ? 'notify_chosed' : 'notify_normal'"
        >已读</div>
      </div>
      <div>
        <div
          v-for="item in notificationData"
          :key="item.id"
          class="header__notify__item"
          @click="updateStatus(item)"
        >
          <div class="item-head d-flex row align-center justify-space-between">
            <p class="item-title">{{ item.content.type === 'EXPIRE' ? '账号提示' : (item.content.code === '200' ? '导出成功' : '导出失败') }}</p>
            <p class="item-time">{{ item.createTime }}</p>
          </div>
          <div
            class="item-content"
            v-if="item.content.type === 'EXPIRE'"
          >
            <span class="title-tips">
              {{ item.content.content ? item.content.content.split('，')[0] : '您的账号密码即将过期' }}
              ，请及时
              <a
                class="export-link"
                @click="showPwdChange"
              >修改密码</a>
            </span>
          </div>
          <div
            class="item-content"
            v-else-if="item.content.code === '200'"
          >
            <span class="title-tips">请点击文件名下载：</span>
            <span
              class="export-link link-limit-size"
              :title="item.fileContent.fileName"
              @click="downloadFile(item)"
            >{{ item.fileContent.fileName }}</span>
            <!-- <a
              v-else
              class="export-link link-limit-size"
              :title="item.fileContent.fileName"
              :href="item.fileContent.fileUrl"
              :download="item.fileContent.fileName"
              :target="item.fileContent.fileName.includes('.pdf') ? '_blank' : '_self'"
            >
              {{ item.fileContent.fileName }}
            </a> -->
          </div>
          <div
            class="item-content"
            v-else
          >
            <span class="title-tips">失败原因：</span>{{ item.content.msg }}
          </div>
        </div>
        <div
          v-if="showLoadingMore"
          slot="loadMore"
          :style="{ textAlign: 'center', marginTop: '12px' }"
        >
          <a-spin v-if="loadingMore" />
          <a-button
            v-else
            @click="loadMore()"
          >
            加载更多
          </a-button>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { queryNotification, updateNotificationStatus } from '@/apis/message';
import { apiDownloadFile } from '@/apis/report';
import { downLoadFunc } from '@/utils/index';

export default {
  data() {
    return {
      visible: false,
      drawerVisible: false,
      currentTab: 1,
      notificationData: [], // 通知
      pager: {
        pageNo: 1,
        pageSize: 10,
      },
      loadingMore: false,
      total: 0,
      totalUnread: 0,
      hasUnreadMessage: 0,
    };
  },
  computed: {
    ...mapState('user', ['globalState']),
    showLoadingMore() {
      return this.pager.pageNo * this.pager.pageSize < this.total;
    },
  },
  watch: {
    drawerVisible(nv) {
      if (nv) {
        this.notificationData = [];
        this.getNotificationData();
      } else {
        // 关闭时查看是否存在未读消息
        this.getUnreadCount();
      }
    },
    globalState(val) {
      if (val) {
        const { notifySuccess } = val;
        this.handleEvent(notifySuccess);
      }
    },
  },
  mounted() {
    this.getUnreadCount();
  },
  // destroyed() {
  //   actions.offGlobalStateChange();
  // },
  methods: {
    downloadFile(data) {
      apiDownloadFile({ fileId: data.fileContent.fileId, fileUrl: data.fileContent.fileUrl, fileName: data.fileContent.fileName }, '/coupon/marketing-file/manage/template/download').then((res) => {
        let fileName = '';
        try {
          // eslint-disable-next-line prefer-destructuring
          fileName = res.filename.split('=')[1] || res.headers['content-disposition'].split('=')[1];
          fileName = decodeURIComponent(fileName);
        } catch (error) {
          const { fileContent } = data;
          // eslint-disable-next-line prefer-destructuring
          fileName = fileContent.fileName;
        }
        downLoadFunc(res.blob, fileName, fileName.includes('.zip') ? 'zip' : 'excel');
      });
    },
    handleEvent(data) {
      if (data === 'primary') return;
      const fileData = JSON.parse(data.content);
      if (fileData.code === '200') {
        this.showSuccessMessage(fileData.data.content[0]);
      } else {
        this.showErrorMessage(fileData);
      }
    },
    showSuccessMessage(file) {
      this.$notification.success({
        message: '导出成功',
        description: h => h('div', [
          h('p', {}, '请点击文件名下载：'),
          h(
            'a',
            {
              class: ['export-link', 'link-limit-size'],
              attrs: {
                href: file.fileUrl,
                download: file.fileName,
                target: file.fileName && file.fileName.includes('.pdf') ? '_blank' : '_self',
              },
            },
            file.fileName,
          ),
        ]),
        duration: 30,
      });
    },
    showErrorMessage(errMsg) {
      this.$notification.error({
        message: '导出失败',
        description: h => h('div', [h('span', {}, `失败原因：${ errMsg.msg}`)]),
        duration: 30,
      });
    },
    showDrawer() {
      this.drawerVisible = true;
    },
    closeDrawer() {
      this.drawerVisible = false;
    },
    handleMenuChagne(item) {
      // 切换未读/已读
      this.currentTab = Number(item);
      setTimeout(() => {
        this.notificationData = [];
        this.total = 0;
        this.loadMore(1);
      });
    },
    loadMore(page) {
      if (page) this.pager.pageNo = page;
      else this.pager.pageNo += 1;
      this.getNotificationData();
    },
    async getUnreadCount() {
      // 判断是否存在未读通知
      const rst = await queryNotification({
        ...this.pager,
        status: 1,
      });
      this.hasUnreadMessage = rst.records.length;
    },
    async getNotificationData() {
      this.loadingMore = true;
      try {
        const rst = await queryNotification({
          ...this.pager,
          status: this.currentTab === 1 ? 1 : 0,
        });
        const retData = rst.records.map((item) => {
          item.content = JSON.parse(item.content);
          // shorten field length
          if (item.content.data && item.content.data.content) {
            [item.fileContent] = item.content.data.content;
          } else {
            item.fileContent = {};
          }
          return item;
        });
        this.notificationData = this.notificationData.concat(retData);
        this.total = rst.total;
        if (this.currentTab === 1) {
          this.totalUnread = rst.total;
        }
      } finally {
        this.loadingMore = false;
      }
    },
    async updateStatus(item) {
      if (!item.status) {
        return;
      }
      await updateNotificationStatus({
        id: item.id,
      });
      this.notificationData = [];
      this.loadMore(1);
      this.$message.success('已标记为已读');
    },
    showPwdChange() {
      this.closeDrawer();
      this.$emit('pwdShow');
    },
  },
};
</script>

<style lang="less">
.header__notify {
  .menu-icon {
    text-align: center;
    cursor: pointer;
    padding: 0 14px;
    .menu-icon-item {
      color: var(--text-color-o-65);
      font-size: 16px;
    }
    .user_name {
      font-weight: bold;
    }
  }
}
.header__notify__tabs {
  height: 50px;
  border-bottom: 1px solid #f0f0f0;
  .notify {
    cursor: pointer;
    box-sizing: border-box;
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    font-weight: bold;
    padding: 0 20px;
    margin-right: 10px;
  }
  .notify_chosed {
    color: #16BFD5;
    border-bottom: 2px solid #16BFD5;
  }
  .notify_normal {
    color: rgba(0,0,0,0.65);
    border-bottom: 2px solid transparent;
  }
  .notify_number {
    margin-left: 5px;
    padding: 4px 8px;
    color: #fff;
    background-color: #ff4d4f;
    border-radius: 10px;
    font-size: 14px;
    line-height: 14px;
    font-weight: bold;
  }
}
.header__notify__item {
  padding: 16px 8px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  .item-head {
    height: 22px;
    margin-bottom: 4px;
  }
  .item-title {
    color: #222;
    font-weight: bold;
    font-size: 14px;
    line-height: 22px;
    margin: 0;
  }
  .item-time {
    font-size: 12px;
    color: #999;
    margin: 0;
  }
  .item-content {
    font-size: 12px;
    color: #999;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
}
.header__notify__item:hover {
  background-color: #F2FEFF;
}
.ant-dropdown:before {
  //为了解决 无法点击自定义的东西
  z-index: -1;
}
.antmain-list-item-action {
  margin-left: 0 !important;
}
.message-wrapper {
  .ant-drawer-body {
    padding: 0;
    .title-tips {
      font-size: 12px;
      color: #999;
      font-weight: normal;
    }
    .export-success {
      color: #52c41a;
    }
    .export-error {
      color: #f5222d;
    }
    .export-time {
      font-size: 12px;
      margin-left: 10px;
      color: #999;
    }
    .ant-menu-item {
      width: 50%;
      text-align: center;
    }
    .ant-list {
      height: calc(100vh - 105px);
      overflow-y: auto;
      .ant-list-item {
        padding: 10px 20px;
        white-space: nowrap;
        p {
          margin-bottom: 5px;
        }
        .ant-list-item-meta-content {
          width: 210px;
        }
        .ant-list-item-meta-description {
          font-size: 12px;
        }
      }
    }
    .ant-pagination {
      margin-top: 20px;
    }
  }
}
.link-limit-size {
  max-width: 250px;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  vertical-align: top;
}
.export-link {
  color: #01acf3;
  + .export-link {
    margin-left: 20px;
  }
}
</style>
